
import { apiFuns } from "sw-hic";
let { get, post, put, del, genStandard } = apiFuns;
let api = {
    ExamineSet: {
        ...genStandard("set","/api/ml"),
    },
    SetDetailId: {
        ...genStandard("setDetail","/api/ml"),
     },
    Standard :{
        ...genStandard("standard","/api/ml"),
    }, 
    item : {
        ...genStandard("item","/api/ml"),
    }
};
export default api;